module.exports = __webpack_public_path__ + "static/media/home_logo_ch@2x.6fbcc28d.png";